import { styled } from 'solid-styled-components';

export const StyledLoadingPlaceHolder = styled.div`
    height: 60vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;